import React from "react";
import { ActivityRow } from "./ActivityRow";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

const PERIODS = {
  matin:      { emoji: "🌅", label: "Matin" },
  apres_midi: { emoji: "🌞", label: "Après-midi" },
  soiree:     { emoji: "🌙", label: "Soirée" },
};

export function PeriodBlock({ period, data }) {
  const { emoji, label } = PERIODS[period] || { emoji: "•", label: period };
  const activites = data?.activites || [];

  if (activites.length === 0) return null;

  return (
    <div className="mb-3" data-testid={`period-block-${period}`}>
      <div className="flex items-center gap-2 py-2 border-b border-[#EDE8E0] mb-1">
        <span className="text-base select-none">{emoji}</span>
        <span
          className="text-sm font-semibold text-[#2B2623]"
          style={{ ...LORA, letterSpacing: "0.04em" }}
        >
          {label}
        </span>
      </div>

      <div>
        {activites.map((activity, idx) => (
          <ActivityRow
            key={activity.id || idx}
            activity={activity}
            isLast={idx === activites.length - 1}
          />
        ))}
      </div>
    </div>
  );
}
